import { Breadcrumb, CardSkeletonLoader, Modal, ErrorBoundary, ProgressIndicator } from '@/components/atoms';
import { PageHeader, SaveCancelFooter } from '@/components/molecules';
import { PageContainer } from '@/components/organisms';
import ReviewBulkPoint from '@/containers/ReviewBulkPointModifiers/ReviewBulkPoint'
import useReviewBulkPointModifier from '@/containers/ReviewBulkPointModifiers/ReviewBulkPointModifier-hooks';
import { MODAL_TYPE } from '@/utils/constants/globalStyle'
import { ROUTES } from '@/utils/constants/routesConstants';
import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom'
import { useAppSelector } from '@/store'

const ReviewBulkPointModifiers = () => {
  const { handlePublish, handleDraft, loading } = useReviewBulkPointModifier()
  const [isCancel, setIsCancel] = useState(false);
  const navigate = useNavigate()
  const {id} = useParams()
  const bulkModifierData = useAppSelector(state => state.bulkModifiers)
  const isReadOnly = !!id; // When there's an id, it's read-only (viewing existing item)

  // Dynamic breadcrumb logic
  const breadcrumbs = useMemo(() => {
    const baseBreadcrumbs = [
      { label: '', href: '/' },
      { label: 'Bulk Point Modifiers', href: '/rewards/bulk-modifiers' }
    ];

    // Check if we have an existing bulk modifier (either from URL id or data uuid/name)
    const hasExistingModifier = id || bulkModifierData?.uuid;
    const modifierName = bulkModifierData?.bulkModifierName || bulkModifierData?.name;

    // Creation flow - no id in URL and no existing data
    if (!hasExistingModifier) {
      return [
        ...baseBreadcrumbs,
        { label: 'Create Bulk Modifiers', href: '/rewards/bulk-modifiers' }
      ];
    }

    // Review/Edit flow - id exists in URL or data has uuid/name
    const displayName = modifierName || 'Loading...';
    return [
      ...baseBreadcrumbs,
      { label: displayName, href: '/rewards/bulk-modifiers' }
    ];
  }, [id, bulkModifierData?.bulkModifierName, bulkModifierData?.name, bulkModifierData?.uuid]);

  const cancelPopup = () => {
    setIsCancel(!isCancel);
  }
  const onClickPrimaryButton = () => {
    navigate(ROUTES.BULK_POINT_MODIFIERS)
  }

  const onClickSecondaryButton = () => {
    setIsCancel(!isCancel)
  }
  return (
    <ErrorBoundary>
      <>
        <Breadcrumb
          uiSchema={{
            isDark: true,
            className: '',
            breadcrumbs: breadcrumbs,
          }}
          id={'cbpm_bradcrumb'}
        />
        <PageHeader title="Create Bulk Point Modifiers" />
        <ProgressIndicator
          currentStep={2}
          completed={false}
          steps={2}
          titles={[{title: 'Setup'}, {title: 'Review'}]}
          onStepClick={step => {
            if (step === 1) {
              navigate(ROUTES.BULK_POINT_MODIFIER_CREATE)
            }
          }}
        />
        {loading ? <PageContainer>
          <CardSkeletonLoader> </CardSkeletonLoader>
        </PageContainer> :
          <ReviewBulkPoint/>
        }
        {!isReadOnly ? (
          <SaveCancelFooter
            isReview={true}
            handleCancel={cancelPopup}
            nextAction={handlePublish}
            draftAction={handleDraft}
          />
        ) : null}

        {isCancel ? (
          <Modal
            type={MODAL_TYPE.FLUID}
            showModal={isCancel}
            onCloseModal={cancelPopup}
            title="Are you sure you want to cancel?"
            text={'Your work will not be saved if you click Yes. To continue editing and go back to the page, click NO'}
            showPrimaryButton={true}
            primaryButtonText="Yes"
            onClickPrimaryButton={onClickPrimaryButton}
            showSecondaryButton={true}
            secondaryButtonText="No"
            onClickSecondaryButton={onClickSecondaryButton}
            footerProps={{
              size: 'medium',
              type: 'primary',
            }}
            isDark={true}
          />
        ) : null}
      </>
    </ErrorBoundary>
  )
}

export default ReviewBulkPointModifiers;